import {
    RemoveFromCart,
    EmptyCart,
    RemoveGiftCardCode,
    RemoveDiscountCode,
    AddDiscountCode,
    getDataUpdateCart,
} from '../../functions/cart';
import {scrollbarSwiper} from "../../functions/slider";
import useBreakpoints from '../../functions/useBreakpoints';
import {InitTooltips} from '../../functions/tooltip';

const {breakpoints} = useBreakpoints();

/** CART/CART-TABLE.TPL **/
document.addEventListener('DOMContentLoaded', () => {
    InitIncrementCart(false);

    $('.tooltip-trigger').hover(
        function () {
            // Mouse in
            $(this).next().removeClass('hidden');
        },
        function () {
            // Mouse out
            $(this).next().addClass('hidden');
        }
    );

    //-- Remove the item from the cart
    $('a.delete, a.delete-mobile').on('click', function () {
        RemoveFromCart($(this).attr('data-delete'));
    });

    //--Add/Remove guarantee
    /*$('.add-guarantee').on('change', function (e) {
        e.preventDefault();
        var strParams = 'intArticleno=' + $(this).data('article');

        if ($(this).is(':checked')) {
            strParams += '&intGuarantee=' + $(this).data('guarantee');
        }

        strParams += '&lang=' + strLang;
        strParams += '&country=' + strCountry;

        $.post(strPath + 'ajax/guarantee.php', strParams, function (data) {
            window.location.reload();
        });

        return false;
    });*/

    const proceedButton = document.querySelectorAll('[data-toggle="proceed"]');

    if (proceedButton) {
        proceedButton.forEach(button => {
            button.addEventListener('click', () => {
                $('form.frm-cart-proceed').trigger('submit');
            });
        });
    }

    //--Empty cart
    if (typeof blnEmptyCart !== 'undefined') {
        EmptyCart();
    }

    //-- Validate discount code (and giftcard code)
    AddDiscountCode();

    //-- Remove discount code
    RemoveDiscountCode();

    //-- Remove giftcard code
    RemoveGiftCardCode();

    /*const returnOldApplianceInputs = document.querySelectorAll('.chk-appliance');

    returnOldApplianceInputs.forEach(input => {
        input.addEventListener('click', (e) => {
            let els = document.querySelectorAll('[value="' + input.value + '"]');
            els.forEach(el => {
                el.classList.toggle('checked');
            });

            const isChecked = IsCheckedBatch();
            let arrInputValues = input.value.split('-');
            const intArticleNo = arrInputValues[0];
            const intPriceNo = arrInputValues[1];
            const strParams = `chk-appliance=${isChecked}&intArticleNo=${intArticleNo}&intPriceNo=${intPriceNo}&checked=${input.classList.contains('checked')}`;

            $.post(strPath + 'ajax/save-return-appliance.php', strParams + '&lang=' + strLang + '&country=' + strCountry, function (data) {
                console.log(data);
            });
        });
    });*/

    const productSliders = document.querySelectorAll('.product-swiper-scrollbar');
    if (productSliders && productSliders.length > 0) {
        productSliders.forEach(slider => {
            scrollbarSwiper(slider, {
                slidesPerView: 1.5,
                breakpoints: {
                    [parseInt(breakpoints.lg)]: {
                        slidesPerView: 3, // Your new value
                    },
                },
            });
        });
    }
});

const IsCheckedBatch = () => {
    let value = false;
    const inputs = document.querySelectorAll('.chk-appliance');

    for (const input of inputs) {
        if (input.classList.contains('checked')) {
            value = true;
            break;
        }
    }

    return value;
};

const InitIncrementCart = (blnCheckStock) => {
    const incrementButtons = document.querySelectorAll('[data-toggle="increment"]');
    const incrementInputs = document.querySelectorAll('[data-quantity]');

    if (incrementInputs) {
        incrementInputs.forEach(input => {
            // Sla originele waarde op voor blur check
            input.dataset.originalValue = input.value;

            ['keypress', 'keydown'].forEach(listener => input.addEventListener(listener, (event) => {
                if (event.key === 'Enter') {
                    event.preventDefault();

                    getDataUpdateCart(
                        event.currentTarget,
                        event.currentTarget.id,
                        blnCheckStock,
                        false,
                    );
                }

                return false;
            }));

            // Blur event - wanneer je uit het veld gaat
            input.addEventListener('blur', (event) => {
                const currentVal = event.currentTarget.value;
                const originalVal = event.currentTarget.dataset.originalValue;

                // Alleen updaten als waarde is gewijzigd
                if (currentVal !== originalVal) {
                    getDataUpdateCart(
                        event.currentTarget,
                        event.currentTarget.id,
                        blnCheckStock,
                        false,
                    );
                }
            });
        });
    }

    if (incrementButtons) {
        incrementButtons.forEach(button => {
            button.addEventListener('click', (event) => {
                getDataUpdateCart(
                    document.getElementById(event.currentTarget.getAttribute('data-tw-target')),
                    event.currentTarget.getAttribute('data-tw-target'),
                    blnCheckStock,
                    true,
                    event.currentTarget,
                );
            });
        });
    }
};